import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  changeModalVisibility,
  setClinicDataToEdit,
  setClinicDataToView,
  setClinicsList,
  setIsClinicsLoading,
} from '../../store/clinicsSlice';
import Button from '../../components/BaseComponents/Button';
import ClinicModal from '../../components/Clinics/ClinicModal';
import './ClinicsPage.scss';
import { getClinicsList } from '../../api/clinics';
import ClinicsTable from '../../components/Clinics/ClinicsListTable';
import Loader from '../../components/BaseComponents/Loader';
import { useNavigate } from 'react-router';
import { UserRoleEnum } from '../../types/apiGeneratedTypes';
import ClinicModalView from '../../components/Clinics/ClinicModalView';

const Clinics: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = React.useState<any>(null);
  const { isAddClinicModalOpened, isClinicsLoading, clinicsCount, clinicDataToView, sortKey, sortOrder } =
    useSelector((state: RootState) => state.clinics);
  const {
    admin: { role },
  } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    if (role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist) {
      navigate('/members');
    }
  }, [role, navigate]);

  useEffect(() => {
    const fetchClinics = async () => {
      try {
        dispatch(setIsClinicsLoading(true));
        
        const clinicsList = await getClinicsList(
          0, 
          10,
          sortKey || undefined,
          sortOrder || undefined
        );
        
        console.log('Clinics fetched:', clinicsList);
        dispatch(setClinicsList(clinicsList.clinics));
      } catch (error) {
        setError(error);
      } finally {
        dispatch(setIsClinicsLoading(false));
      }
    };

    fetchClinics();
  }, [sortKey, sortOrder, dispatch]);

  const onAddClinicBtnClick = () => {
    dispatch(setClinicDataToEdit(null));
    dispatch(changeModalVisibility(true));
  };
  const onModalClose = () => {
    dispatch(changeModalVisibility(false));
  };

  if (isClinicsLoading) return <Loader />;
  if (error) return <div>Error while loading clinics list...</div>;

  return (
    <div className='page-container'>
      <div className='search-row-container'>
        <div className='search-and-filter-container'></div>
        <Button
          isSecondary={true}
          text='Add Clinic'
          onClick={onAddClinicBtnClick}
        />
      </div>
      <ClinicsTable key={clinicsCount} />
      <ClinicModal isOpen={isAddClinicModalOpened} onClose={onModalClose} />
      <ClinicModalView
      // isOpen={true} 
      isOpen={clinicDataToView !== null} 
      onClose={() => dispatch(setClinicDataToView(null))} />
    </div>
  );
};
export default Clinics;
